import {
  ADMIN_ROUTES,
  SYSTEM_ROUTES,
} from 'applications/GSP/shared/constants/router/routePaths';
import { useStudent } from 'applications/GSP/shared/hooks/user';
import { matchRouteNotStrict } from 'shared/utils/router';

export const useIsAdminRoute = () => {
  const student = useStudent();

  return (
    ADMIN_ROUTES.some(route => matchRouteNotStrict(route)) ||
    (SYSTEM_ROUTES.some(route => matchRouteNotStrict(route)) && !student)
  );
};
